/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_EditInputs */

const en_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const ar_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعديل`)
};

const bn_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এডিট`)
};

const de_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

const es_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const fr_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier`)
};

const pt_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar`)
};

const zh_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑`)
};

const tr_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzenle`)
};

const ru_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Редактировать`)
};

const pl_resume_edit = /** @type {(inputs: Resume_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edytuj`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Resume_EditInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_edit = /** @type {((inputs?: Resume_EditInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_EditInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_edit(inputs)
	if (locale === "bn") return bn_resume_edit(inputs)
	if (locale === "de") return de_resume_edit(inputs)
	if (locale === "es") return es_resume_edit(inputs)
	if (locale === "fr") return fr_resume_edit(inputs)
	if (locale === "pt") return pt_resume_edit(inputs)
	if (locale === "zh") return zh_resume_edit(inputs)
	if (locale === "tr") return tr_resume_edit(inputs)
	if (locale === "ru") return ru_resume_edit(inputs)
	if (locale === "pl") return pl_resume_edit(inputs)
	return en_resume_edit(inputs)
});